import { baseApi } from "./baseApi";

const DRIVER_VEHICLE_DEPARTURE_BASE_URL = "/driver-vehicle-departure";

export const DriverVehicleDepartureApi = baseApi.injectEndpoints({
    tagTypes: ["DriverVehicleDeparture"],

    endpoints: (builder) => ({
        addDriverVehicleDeparture: builder.mutation({
            query: (payload) => ({
                url: DRIVER_VEHICLE_DEPARTURE_BASE_URL,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: (_result, _error, { _id }) => [
                { type: "DriverVehicleDeparture", id: _id },
                { type: "DriverVehicleDeparture", id: "LIST" },
            ],
        }),

        listDriverVehicleDeparture: builder.query({
            query: (params) => ({
                url: DRIVER_VEHICLE_DEPARTURE_BASE_URL,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ _id }) => ({
                            type: "DriverVehicleDeparture",
                            id: _id,
                        })),
                        { type: "DriverVehicleDeparture", id: "LIST" },
                    ]
                    : [{ type: "DriverVehicleDeparture", id: "LIST" }],
        }),
        listDriverVehicleRoutine: builder.query({
            query: (params) => ({
                url: `${DRIVER_VEHICLE_DEPARTURE_BASE_URL}/vehicleRoutine`,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ _id }) => ({
                            type: "DriverVehicleDeparture",
                            id: _id,
                        })),
                        { type: "DriverVehicleDeparture", id: "LIST" },
                    ]
                    : [{ type: "DriverVehicleDeparture", id: "LIST" }],
        }),

        getDDLDriverVehicleDeparture: builder.query({
            query: (params) => ({
                url: `${DRIVER_VEHICLE_DEPARTURE_BASE_URL}/ddl`,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ _id }) => ({
                            type: "DriverVehicleDeparture",
                            id: _id,
                        })),
                        { type: "DriverVehicleDeparture", id: "DDL" },
                    ]
                    : [{ type: "DriverVehicleDeparture", id: "DDL" }],
        }),

        updateDriverVehicleDeparture: builder.mutation({
            query: ({ _id, ...body }) => ({
                url: `${DRIVER_VEHICLE_DEPARTURE_BASE_URL}/${_id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (_result, _error, { _id: id }) => [
                { type: "DriverVehicleDeparture", id },
                { type: "DriverVehicleDeparture", id: "LIST" },
            ],
        }),

        getDriverDetailForRoutine: builder.query({
            query: (routeId) => `${DRIVER_VEHICLE_DEPARTURE_BASE_URL}/${routeId}`,
            providesTags: (result, error, { _id: id }) => [
                { type: "DriverVehicleDeparture", id },
                { type: "DriverVehicleDeparture", id: "LIST" },
            ],
        }),

    }),
});

export const {
useAddDriverVehicleDepartureMutation,
    useListDriverVehicleDepartureQuery,
    useLazyListDriverVehicleDepartureQuery,
    useLazyGetDriverDetailForRoutineQuery,
    useLazyListlistDriverVehicleRoutineQuery,
    useLazyGetDDLDriverVehicleDepartureQuery,
    useUpdateDriverVehicleDepartureMutation,
} = DriverVehicleDepartureApi;
